<template>
    <DataTable
            v-redirect-if-no-permission:SERVICES
            v-if="name" :url="api.ACTIONS.SERVICE_CARS(id)"
            descending
            :titles="titles"
            :title='name + " - Attached Cars"'
            :enable-edit="false"
            :enable-delete="false"
            :fields-hidden-main="['color_id', 'car_document', 'insurance_document', 'car_brand_id','brand_model_id','approved','deny_reason', 'pivot', 'deleted_at', 'captain_id']"
            :fields-hidden-add="['id','captain','brand', 'car_brand_id','model','color','insurance_expired_date','car_manufacture_year','number','insurance_document',
               'car_document','captain_id','color_id','brand_model_id','approved','deny_reason','deleted_at','created_at','updated_at','pivot']"
            :fields-extra-add="fieldsExtraAdd"
            :selected-actions="selectedActions"
            :selectable="'Select'"
            :formatter="formatter"
    ></DataTable>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "ServiceCars",
        title: 'Cars',
        components: {DataTable},
        data() {
            return {
                id: null,
                name: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || "Unknown";
        },
        computed: {
            formatter() {
                const api = this.api;
                return {
                    insurance_document(value) {
                        if (value == null) return "Un-loadable";
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" style="width: 75px" class="img-thumbnail"/>`;
                    },
                    car_document(value) {
                        if (value == null) return "Un-loadable";
                        if (value[0] !== '/') value = "/" + value;
                        return `<img src="${api.IMAGES_URL + value}" style="width: 75px" class="img-thumbnail"/>`;
                    },
                    created_at: (val) => this.moment(val).format('MMM DD YYYY'),
                    updated_at: (val) => this.moment(val).format('MMM DD YYYY')
                }
            },
            titles() {
                return {
                    id: "#",
                    cars: "Captains To Add",
                    car_manufacture_year: 'Manu. Year',
                    insurance_expired_date: 'Ins. expired'
                }
            },
            fieldsExtraAdd() {
                return {
                    cars: "choose-cars"
                }
            },
            selectedActions() {
                return {
                    "Delete": {
                        color: "error",
                        title: "Delete",
                        do: async (items) => {
                            try {
                                let params = new URLSearchParams();
                                let index = 0;
                                for (let item of items) params.append("cars[" + (index++) + "]", item.id);
                                await this.axios.delete(this.api.ACTIONS.SERVICES + "/" + this.id + "/cars?" + params.toString());
                                window.getApp.$emit("SHOW_TOAST", "Deleted", "green");
                                return {
                                    shouldClearSelected: true,
                                    shouldReloadData: true
                                }
                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", "Failed!", "red");
                            }

                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>